import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=07be3e86&scoped=true&"
import script from "./TaskIndex.vue?vue&type=script&lang=js&"
export * from "./TaskIndex.vue?vue&type=script&lang=js&"
import style0 from "./TaskIndex.vue?vue&type=style&index=0&id=07be3e86&prod&lang=scss&"
import style1 from "./TaskIndex.vue?vue&type=style&index=1&id=07be3e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be3e86",
  null
  
)

export default component.exports